
<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="所属菜单">
          <a-input disabled v-decorator="['name']"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="action"
          hasFeedback
        >
          <a-input
            placeholder="请输入action"
            autocomplete="off"
            v-decorator="['action',{rules:[{ required: true, message: 'action不能为空！' },{
              pattern: /^[^\s]*$/,
              message: 'action不能包含空格！'},{
                max: 50,
                message: '最多可输入50个字'}]}]"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="method"
          hasFeedback
        >
          <a-select v-decorator="['method',{rules:[{ required: true, message: '请选择method！' },]}]" @change="handleSelectChange">
            <a-select-option v-for="item in queryList" :key="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="url"
          hasFeedback
        >
          <a-input
            placeholder="请输入url"
            autocomplete="off"
            v-decorator="['url',{rules:[{ required: true, message: 'url不能为空！'},{
              pattern: /^[^\s]*$/,
              message: 'url不能包含空格！'},{
                max: 100,
                message: '最多可输入100个字'}]}]"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="备注"
          hasFeedback
        >
          <a-textarea
            placeholder="请输入按钮功能简述"
            :autosize="{ minRows: 2, maxRows: 4 }"

            v-decorator="['remark', { rules: [{ required: true, message: '按钮功能简述不能为空！' },{
              pattern: /^[^\s]*$/,
              message: '按钮功能简述不能包含空格！'},{
                max: 255,
                message: '最多可输入255个字'}] }]"
          />
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" html-type="submit" style="margin-right:10px;">
            提交
          </a-button>
          <a-button style="margin-right:10px;" @click="cancel">
            取消
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { addButton, updateButton, getQuery } from '@/api/button'
export default {
  name: 'EditBtnModal',
  mounted () {

  },
  computed: {
    // isEdit () {
    //   return this.type !== this.$sysInfo.MODAL_VIEW
    // },
    ...mapGetters([
      'menuList',
      'btnInfo'
    ])
  },
  watch: {
    menuList () {
    },
    btnInfo () {
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 600,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'button' }),
      visible: false,
      defaultModel: {},
      model: {

      },
      titleName: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      queryList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (m) {
      const models = Object.assign({}, m)
      this.model = models
    },
    // 设置name
    setName (data) {
      const datas = Object.assign({}, data)
      this.titleName = datas.name
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.getSelectInfo()
      this.visible = flag
      if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
        if (flag) {
          this.getModelInfo(this.model)
        }
      } else {
        // debugger
        setTimeout(() => {
          this.form.setFieldsValue({
            name: this.titleName
          })
        })
      }
    },
    // 提交按钮新增/修改
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const arg = {
            menuId: this.menuList.id,
            action: value.action,
            url: value.url,
            method: value.method,
            remark: value.remark
          }
          if (this.type === this.$sysInfo.MODAL_ADD) {
            addButton(arg).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            arg.id = this.model.id
            updateButton(arg).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      this.infoLoading = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          // id:this.model.id,
          'action': this.model.action,
          'url': this.model.url,
          'method': this.model.method,
          'remark': this.model.remark,
          'name': this.model.menuName
        })
      })
      // this.titleName = this.model.menuName;
      this.infoLoading = false
    },
    handleChange () {

    },
    // 清空表单
    formClear () {
      // setTimeout(()=> {
      this.form.setFieldsValue({ 'url': '', 'action': '', 'method': '', 'remark': '', 'name': '' })
      // })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    getSelectInfo () {
      // this.queryList = [
      //   { value: 'GET', label: 'GET' },
      //   { value: 'POST', label: 'POST' },
      //   { value: 'PUT', label: 'PUT' },
      //   { value: 'DELETE', label: 'DELETE' },
      // ]
      const params = {
        pCode: 'HTTP_TYPE'
      }
      getQuery(params).then(res => {
        if (res.status === 0) {
          this.queryList = res.data.map(function (item) {
            return {
              value: item.code,
              label: item.code
            }
          })
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    // 获取select列表
    handleSelectChange (value) {

    }
  }
}
</script>

<style scoped>

</style>
